import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import CheckoutConfirmation from '@features/checkout/components/CheckoutConfirmation/CheckoutConfirmation'
import clsx from 'clsx'
import { FC } from 'react'
import s from './Confirmation.module.scss'
interface ConfirmationProps {
  orderId: string
  orderConfirmationText: string
}

const Confirmation: FC<ConfirmationProps> = ({
  orderId,
  orderConfirmationText,
}) => {
  return (
    <div className={clsx('container', s.root)}>
      <TrustedHtml
        html={orderConfirmationText}
        className={s.confirmationText}
      />
      <CheckoutConfirmation orderId={orderId} />
    </div>
  )
}

export default Confirmation
